import { IonIcon } from "@ionic/react";
import classNames from "classnames/bind";
import { heart, heartOutline } from "ionicons/icons";
import React from "react";
import styles from "./MainPageProduct.module.scss";
import { Product } from "@core/types";
import { useConfig } from "../../../../../providers/config";
import { useWishListData } from "../../../../../providers/wishListStore";

interface WishlistButtonProps {
  product: Product;
}

const cx = classNames.bind(styles);

export const WishlistButton = ({ product }: WishlistButtonProps) => {
  const config = useConfig();
  const { toggleWish, isWishProduct } = useWishListData();

  return (
    <div
      className={cx(
        "productsSpecialLeft__heart",
        config?.cardProduct ? "productCommon__heart_fortime" : "productCommon__heart"
      )}
    >
      <div
        className="max-w-[24px] max-h-[24px]"
        onClick={(e) => {
          toggleWish(product.id);
          e.stopPropagation();
        }}
      >
        <IonIcon
          className={cx("productHeartIcon")}
          color={isWishProduct(product.id) ? "secondary" : "light"}
          icon={isWishProduct(product.id) ? heart : heart}
        />
        <IonIcon className={cx("productHeartIcon absolute right-0 z-1000")} color={"secondary"} icon={heartOutline} />
      </div>
    </div>
  );
};
